import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { usePermissions } from '../hooks/usePermissions';
import { UserRole } from '../contexts/PermissionsContext';

interface RoleProtectedRouteProps {
  allowedRoles: UserRole[];
  redirectTo?: string;
  children: React.ReactNode;
}

export const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  allowedRoles,
  redirectTo = '/home',
  children,
}) => {
  const { permissions, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!permissions || (permissions.role !== 'admin' && !allowedRoles.includes(permissions.role))) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
